import { motion } from 'framer-motion'
import { cn } from '../utils/helpers'

const Card = ({ 
  children, 
  className = '', 
  variant = 'soft', 
  hover = false,
  onClick,
  ...props 
}) => {
  const variants = {
    soft: 'soft-card',
    glass: 'glass-card',
    gradient: 'gradient-card',
  }

  const Component = onClick ? motion.button : motion.div

  return (
    <Component
      className={cn(variants[variant], className, hover && 'hover:shadow-2xl transition-shadow duration-300', onClick && 'cursor-pointer', 'min-w-0')}
      onClick={onClick}
      whileHover={hover ? { scale: 1.02, y: -2 } : {}}
      whileTap={onClick ? { scale: 0.98 } : {}}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      {...props}
    >
      {children}
    </Component>
  )
}

export default Card

